import React, { useState } from 'react';
import styles from '../styles/Login.module.css';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../services/apiClient'; 

const LoginPage: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const response = await apiClient('auth/login', {
                method: 'POST',
                body: JSON.stringify({ name: email, password }), 
            });

            if (response.token) {
                localStorage.setItem('authToken', response.token);
                localStorage.setItem('userEmail', response.email);
                localStorage.setItem('userName', response.name);
                
                // --- 👇 CORRECCIÓN AQUÍ 👇 ---
                // Tu entidad usa 'rol', pero por si acaso el backend lo mapea a 'role', revisamos ambos.
                const userRole = response.rol || response.role || 'observador';
                localStorage.setItem('userRole', userRole); 
                // -----------------------------

                // Debug para ver qué está llegando
                console.log("Login exitoso. Rol guardado:", userRole);

                navigate('/dashboard');
            } else {
                throw new Error('No se recibió un token válido.');
            }

        } catch (err: any) {
            console.error("Error de login:", err);
            setError(err.message || 'Credenciales incorrectas.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.loginContainer}>
            <form className={styles.loginForm} onSubmit={handleLogin}>
                <h1 className={styles.title}>Acceso de Administración</h1>
                <p className={styles.subtitle}>PASO | Arquitectura Sostenible</p>
                
                {error && (
                    <div style={{ color: 'red', marginBottom: '1rem', fontSize: '0.9rem' }}>
                        {error}
                    </div>
                )}

                <div className={styles.formGroup}>
                    <label htmlFor="email">Usuario:</label>
                    <input 
                        type="text" 
                        id="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                    />
                </div>
                
                <div className={styles.formGroup}>
                    <label htmlFor="password">Contraseña:</label>
                    <input 
                        type="password" 
                        id="password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        required 
                    />
                </div>
                
                <button type="submit" className={styles.loginButton} disabled={loading}>
                    {loading ? 'Verificando...' : 'Ingresar'}
                </button>
            </form>
        </div>
    );
};

export default LoginPage;